import React from "react";
import StyleFields from "./StyleFields";
import ParameterFields from "./ParameterFields";
import PreviewFields from "./PreviewFields";
import HostingFields from "./HostingFields";
import CodeFields from "./CodeFields";
import classnames from "classnames";

const EmbedPage = () => {
  return (
    <div className="w-100">
      {[
        <StyleFields />,
        <ParameterFields />,
        <HostingFields />,
        <PreviewFields />,
        <CodeFields />
      ].map((node, nodeIx) => (
        <div
          className={classnames("w-100", {
            pt3: nodeIx
          })}
          key={nodeIx}
        >
          {node}
        </div>
      ))}
    </div>
  );
};

export default EmbedPage;
